<ng-container *transloco="let t; read: 'ACCOUNT_EMAIL_MODAL_COMPONENT'">
  <ion-toolbar>
    <div class="toolbar-header">
      <ion-button (click)="dismissModal()" fill="none" color="secondary">
        <ion-icon slot="icon-only" name="arrow-back-outline"></ion-icon>
      </ion-button>
      <h1>{{ t('TITLE') }}</h1>
      <div class="right"></div>
    </div>
  </ion-toolbar>

  <ion-content class="ion-padding">
    <form class="mx-32-desktop" [formGroup]="form" (submit)="onSubmit()" autocomplete="off">
      <h3>{{ t('EDIT_EMAIL') }}</h3>

      <app-password formControlName="password" [withValidators]="false" [label]="t('PASSWORD')"></app-password>

      <app-form-control class="mt-16" [label]="t('NEW_EMAIL')">
        <ion-item fill="outline">
          <ion-input formControlName="email" autocomplete="off"> </ion-input>
          <div class="slot-error" slot="error" *ngIf="emailCtrl?.touched && emailCtrl?.hasError('required')">
            {{ t('EMAIL_REQUIRED') }}
          </div>

          <div class="slot-error" slot="error" *ngIf="emailCtrl?.touched && emailCtrl?.hasError('email')">
            {{ t('EMAIL_FORMAT') }}
          </div>
        </ion-item>
      </app-form-control>

      <div class="flex-column items-center mt-32">
        <app-error-container class="mb-16 fade-in self-stretch" *ngIf="requestStatus.value === 'error'" [errorKey]="requestStatus.error.errorKey">
        </app-error-container>
        <ion-button [disabled]="form.invalid" type="submit" color="primary" class="mt-24 self-stretch desktop-centered">
          <span>{{ t('VALIDATE') }}</span>
          <app-pre-loader *ngIf="requestStatus.value === 'pending'"></app-pre-loader>
        </ion-button>
      </div>
    </form>

    <app-debug-form *appIfDebug [formGroup]="form"></app-debug-form>
  </ion-content>
</ng-container>
